/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {EmailActivityStatus} from './EmailActivityStatus';
import {EmailActivitySubscription} from './EmailActivitySubscription';

/**
 * The EmailIdActivitiesBody model module.
 * @module model/EmailIdActivitiesBody
 * @version 1.0.0
 */
export class EmailIdActivitiesBody {
  /**
   * Constructs a new <code>EmailIdActivitiesBody</code>.
   * @alias module:model/EmailIdActivitiesBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailIdActivitiesBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailIdActivitiesBody} obj Optional instance to populate.
   * @return {module:model/EmailIdActivitiesBody} The populated <code>EmailIdActivitiesBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailIdActivitiesBody();
      if (data.hasOwnProperty('propertyId'))
        obj.propertyId = ApiClient.convertToType(data['propertyId'], 'String');
      if (data.hasOwnProperty('status'))
        obj.status = EmailActivityStatus.constructFromObject(data['status']);
      if (data.hasOwnProperty('subscription'))
        obj.subscription = EmailActivitySubscription.constructFromObject(data['subscription']);
    }
    return obj;
  }
}

/**
 * @member {String} propertyId
 */
EmailIdActivitiesBody.prototype.propertyId = undefined;

/**
 * @member {module:model/EmailActivityStatus} status
 */
EmailIdActivitiesBody.prototype.status = undefined;

/**
 * @member {module:model/EmailActivitySubscription} subscription
 */
EmailIdActivitiesBody.prototype.subscription = undefined;

